import uleThumb from './zdjecia/Pasieka/web/ule-thumb.webp';
import uleFull from './zdjecia/Pasieka/web/ule.webp';
import tabliczkaThumb from './zdjecia/Pasieka/web/tabliczka-thumb.webp';
import tabliczkaFull from './zdjecia/Pasieka/web/tabliczka.webp';
import grykaThumb from './zdjecia/Pasieka/web/miod-gryczany-thumb.webp';
import grykaFull from './zdjecia/Pasieka/web/miod-gryczany.webp';
import borowkaPosterThumb from './zdjecia/Pasieka/web/miod-borowka-poster-thumb.webp';
import borowkaPoster from './zdjecia/Pasieka/web/miod-borowka-poster.webp';
import borowkaSrc from './zdjecia/Pasieka/web/miod-borowka.mp4';

// Galeria „Z życia pasieki": zdjęcia (thumb + pełny WebP) i filmy
// (poster + MP4 ładowane dopiero na żądanie, żeby nie obciążały startu).
export const GALLERY = [
  {
    id: 'ule',
    type: 'photo',
    thumb: uleThumb,
    full: uleFull,
    alt: 'Rząd kolorowych uli Przytulnej Pasieki wśród zieleni',
    caption: 'Nasze ule wśród zieleni'
  },
  {
    id: 'tabliczka',
    type: 'photo',
    thumb: tabliczkaThumb,
    full: tabliczkaFull,
    alt: 'Drewniany szyld Polskie Miody Przytulna Pasieka na tle uli',
    caption: 'Szyld naszej pasieki'
  },
  {
    id: 'miod-gryczany',
    type: 'photo',
    thumb: grykaThumb,
    full: grykaFull,
    alt: 'Świeżo rozlane słoiki miodu gryczanego',
    caption: 'Świeżo rozlany miód gryczany'
  },
  {
    id: 'miod-borowka',
    type: 'video',
    thumb: borowkaPosterThumb,
    full: borowkaSrc,
    poster: borowkaPoster,
    alt: 'Film: miód z borówką amerykańską',
    caption: 'Miód z borówką amerykańską'
  }
];
